@if (proveedorCodigo()) {
<div class="tema-movil min-h-screen bg-[var(--bg)] pb-8">
  <div class="text-white px-5 py-4 flex items-center justify-between sticky top-0 z-10" style="background: var(--ink)">
    <div class="flex items-center gap-2.5">
      <button
        type="button"
        (click)="volverAlListado()"
        aria-label="Volver al listado de proveedores"
        class="flex items-center gap-1 text-[12px] font-bold text-white px-2.5 py-1.5 rounded-lg border border-white/30 bg-white/10 shrink-0"
      >
        ← Volver
      </button>
      <div>
        <div class="font-mono text-[13px] font-bold">{{ encabezadoProveedor() }} · P{{ productoNum().toString().padStart(2, '0') }}</div>
        <div class="text-[11px] text-[#AEB9CC]">Producto en captura</div>
      </div>
    </div>
    <div class="text-[11px] text-[var(--coral-soft)]">⬆ {{ pendientes() }} en cola</div>
  </div>

  @if (confirmandoVolver()) {
    <div class="fixed inset-0 z-40 bg-black/45 flex items-end sm:items-center justify-center p-3">
      <div class="w-full max-w-sm bg-[var(--surface)] rounded-2xl border border-[var(--border)] shadow-xl p-4">
        <p class="text-[13.5px] font-bold mb-1.5">Tienes cambios sin guardar</p>
        <p class="text-[12px] text-[var(--muted)] mb-3">
          ¿Deseas volver? Los cambios se perder&aacute;n.
        </p>
        <div class="flex items-center gap-2.5">
          <button type="button" (click)="cancelarVolver()" class="flex-1 text-[13px] font-semibold py-2.5 rounded-lg border border-[var(--border)]">
            Cancelar
          </button>
          <button
            type="button"
            (click)="confirmarVolverSinGuardar()"
            class="flex-1 text-[13px] font-bold py-2.5 rounded-lg text-white"
            style="background: var(--coral-ink)"
          >
            Volver
          </button>
        </div>
      </div>
    </div>
  }

  <div class="p-4 space-y-3">
    @if (espacioBajo()) {
      <div class="bg-[var(--coral-soft)] text-[var(--coral-ink)] rounded-xl px-3.5 py-2.5 text-[12px] font-semibold">
        ⚠ Poco espacio libre en el dispositivo — sincroniza pronto o libera espacio antes de seguir capturando.
      </div>
    }
    @if (productosGuardados().length > 0) {
      <div class="bg-[var(--surface)] border border-[var(--border)] rounded-xl px-3.5 py-3">
        <p class="text-[11px] font-bold uppercase tracking-wide text-[var(--faint)] mb-2">
          Productos ya guardados de {{ encabezadoProveedor() }} ({{ productosGuardados().length }})
        </p>
        <div class="space-y-1.5">
          @for (item of productosConFotoPrevia(); track item.producto.productoId) {
            <button
              type="button"
              (click)="abrirDetalle(item.producto)"
              class="w-full text-left rounded-lg border border-[var(--border)] px-2.5 py-2 bg-[var(--surface)] active:bg-[var(--surface-2)]"
            >
              <div class="flex items-center gap-2">
                @if (item.fotoPrevia) {
                  <div
                    (click)="abrirImagenPrevia($event, item.fotoPrevia, item.producto.productoId)"
                    title="Ver foto en grande"
                    class="shrink-0 rounded-md cursor-pointer ring-2 ring-transparent hover:ring-[var(--coral-ink)] transition-colors"
                  >
                    <app-mini-foto-blob
                      [blob]="item.fotoPrevia"
                      alt=""
                      className="w-8 h-8 rounded-md object-cover bg-[var(--surface-2)]"
                    />
                  </div>
                }
                <div class="min-w-0 flex-1 flex items-center justify-between text-[12.5px] gap-2">
                  <span class="font-mono text-[var(--blue-ink)]">{{ item.producto.productoId }}</span>
                  <span class="text-[var(--muted)]">
                    {{ item.producto.telas.length }} tela(s) · {{ item.producto.sincronizado === 1 ? 'Guardado online' : 'Guardado local' }}
                  </span>
                </div>
              </div>
              @if (item.producto.telas.length > 0) {
                <div class="mt-1.5 space-y-1">
                  @for (t of item.producto.telas; track t.id) {
                    <div class="text-[11px] text-[var(--muted)]">
                      <span class="font-mono text-[var(--blue-ink)]">{{ t.muestrario || t.id }}</span>
                      {{ ' ' }}· {{ t.colores.join(', ') || 'Sin color' }} · {{ t.tipo || 'Sin tipo' }}
                    </div>
                  }
                </div>
              }
              <div class="mt-1 text-[10.5px] text-[var(--faint)]">Toca para ver el detalle</div>
            </button>
          }
        </div>

        @if (imagenAmpliada(); as img) {
          <app-visor-imagen [url]="img.url" [titulo]="img.titulo" (cerrar)="cerrarImagenAmpliada()" />
        }
      </div>
    }

    <!-- Reiniciamos la galeria al cambiar de producto para evitar fotos retenidas. -->
    @for (n of [productoNum()]; track n) {
      <app-galeria-fotos
        etiquetaSeccion="Foto general del mueble (opcional si ya fotografiaste la tela)"
        [fotos]="fotosProducto()"
        (agregar)="alAgregarFotoProducto($event)"
        (renombrar)="alRenombrarFotoProducto($event)"
        (eliminar)="alEliminarFotoProducto($event)"
      />
    }

    @if (telasDelProducto().length > 0) {
      <p class="text-[11px] font-bold uppercase tracking-wide text-[var(--faint)] pt-2">
        Telas de este producto ({{ telasDelProducto().length }})
      </p>
      @for (t of telasDelProducto(); track t.id) {
        <div class="flex items-center gap-3 bg-[var(--surface)] border border-[var(--border)] rounded-xl px-3.5 py-2.5">
          <div class="flex gap-1">
            @if (t.fotoFrenteBlob) {
              <app-mini-foto-blob [blob]="t.fotoFrenteBlob" alt="" className="w-10 h-10 rounded-md object-cover border border-[var(--border)]" />
            }
            @if (t.fotoReversoBlob) {
              <app-mini-foto-blob [blob]="t.fotoReversoBlob" alt="" className="w-10 h-10 rounded-md object-cover border border-[var(--border)]" />
            }
          </div>
          <div class="flex-1 min-w-0">
            <div class="font-mono text-[10px] text-[var(--blue-ink)]">{{ t.muestrario || t.id }}</div>
            <div class="text-[13px] font-bold truncate">{{ t.colores.join(', ') }}</div>
            <div class="text-[11px] text-[var(--muted)]">{{ t.tipo }}</div>
          </div>
          <button (click)="editarTela(t)" class="text-[11.5px] font-bold px-3 py-1.5 rounded-lg bg-[var(--bg)]">Editar ✎</button>
          <button (click)="pedirBorrarTela(t.id)" class="text-[11.5px] font-bold px-3 py-1.5 rounded-lg text-[var(--coral-ink)]">🗑</button>
        </div>
      }
    }

    @if (borrandoTelaId(); as btId) {
      <div class="fixed inset-0 z-40 bg-black/45 flex items-end sm:items-center justify-center p-3">
        <div class="w-full max-w-sm bg-[var(--surface)] rounded-2xl border border-[var(--border)] shadow-xl p-4">
          <p class="text-[13.5px] font-bold mb-3">¿Eliminar esta tela? No se puede deshacer.</p>
          <div class="flex items-center gap-2.5">
            <button type="button" (click)="cancelarBorrarTela()" class="flex-1 text-[13px] font-semibold py-2.5 rounded-lg border border-[var(--border)]">
              Cancelar
            </button>
            <button
              type="button"
              (click)="confirmarBorrarTela()"
              [disabled]="eliminandoTela()"
              class="flex-1 text-[13px] font-bold py-2.5 rounded-lg text-white disabled:opacity-50"
              style="background: var(--coral-ink)"
            >
              {{ eliminandoTela() ? 'Eliminando…' : 'Eliminar' }}
            </button>
          </div>
        </div>
      </div>
    }

    <div id="constructor-tela" class="border-2 border-dashed rounded-xl p-3.5 mt-3" style="border-color: var(--blue)">
      <p class="text-[11px] font-bold uppercase tracking-wide mb-2" style="color: var(--blue-ink)">
        {{ editandoTelaId() ? 'Editando tela' : '+ Nueva tela' }}
      </p>
      <div class="grid grid-cols-2 gap-2 mb-3">
        <app-camara-captura etiqueta="Frente" (foto)="alCapturarFrenteTela($event)" [fotoPreviaUrl]="fotoFrentePreviaUrl()" />
        <app-camara-captura etiqueta="Reverso" (foto)="fotoReverso.set($event)" [fotoPreviaUrl]="fotoReversoPreviaUrl()" />
      </div>

      <p class="text-[10px] font-bold uppercase tracking-wide text-[var(--faint)] mb-1.5">Colores — toca o escribe (varios)</p>
      <app-banco-chips [banco]="bancoColores()" [seleccionados]="colores()" [multiple]="true" variante="color"
                        (cambiar)="colores.set($event)" [onAgregarAlBanco]="alAgregarColor.bind(this)" [onEliminarDelBanco]="alEliminarColor.bind(this)" />

      <p class="text-[10px] font-bold uppercase tracking-wide text-[var(--faint)] mb-1.5 mt-3">Tipo — uno solo</p>
      <app-banco-chips [banco]="bancoTipos()" [seleccionados]="tipo()" [multiple]="false" variante="tipo"
                        (cambiar)="tipo.set($event)" [onAgregarAlBanco]="alAgregarTipo.bind(this)" [onEliminarDelBanco]="alEliminarTipo.bind(this)" [sinBorrar]="tiposSemilla" />

      <div class="mt-3">
        <label for="captura-id-muestrario" class="block text-[10px] font-bold uppercase tracking-wide text-[var(--faint)] mb-1">ID muestrario</label>
        <input id="captura-id-muestrario" [ngModel]="idTela()" (ngModelChange)="idTela.set($event)" placeholder="HT-2051"
               class="w-full border border-[var(--border)] rounded-lg px-3 py-2.5 text-[13.5px] bg-[var(--surface)]" />
        @if (leyendoIdMuestrario()) {
          <p class="text-[11px] text-[var(--faint)] mt-1">🔎 Leyendo ID de muestrario…</p>
        }
      </div>

      @if (mensajeTela()) {
        <p class="text-[11.5px] mt-2 font-semibold text-[var(--coral-ink)]">{{ mensajeTela() }}</p>
      }

      <button (click)="guardarTelaLista()" class="w-full mt-3 text-[13.5px] font-bold py-3 rounded-lg text-white" style="background: var(--sage)">
        ✔ {{ editandoTelaId() ? 'Guardar cambios' : 'Tela lista' }}
      </button>
    </div>

    <p class="text-[11px] font-bold uppercase tracking-wide text-[var(--faint)] pt-2">Datos del producto</p>
    <div class="grid grid-cols-2 gap-2">
      <div>
        <label for="captura-fob" class="block text-[10px] font-bold uppercase tracking-wide text-[var(--faint)] mb-1">Precio FOB (USD)</label>
        <input id="captura-fob" [ngModel]="fob()" (ngModelChange)="fob.set($event)" inputmode="decimal"
               class="w-full border border-[var(--border)] rounded-lg px-3 py-2.5 text-[13.5px] bg-[var(--surface)]" />
      </div>
      <div>
        <label for="captura-moq" class="block text-[10px] font-bold uppercase tracking-wide text-[var(--faint)] mb-1">MOQ</label>
        <input id="captura-moq" [ngModel]="moq()" (ngModelChange)="moq.set($event)" placeholder="50 sets"
               class="w-full border border-[var(--border)] rounded-lg px-3 py-2.5 text-[13.5px] bg-[var(--surface)]" />
      </div>
      <div class="col-span-2">
        <label for="captura-unidades-contenedor" class="block text-[10px] font-bold uppercase tracking-wide text-[var(--faint)] mb-1">Unidades/contenedor</label>
        <input id="captura-unidades-contenedor" [ngModel]="unidadesPorContenedor()" (ngModelChange)="unidadesPorContenedor.set($event)"
               inputmode="numeric" placeholder="Ej. 100"
               class="w-full border border-[var(--border)] rounded-lg px-3 py-2.5 text-[13.5px] bg-[var(--surface)]" />
      </div>
    </div>
    <div>
      <label for="captura-color-estructura" class="block text-[10px] font-bold uppercase tracking-wide text-[var(--faint)] mb-1">Color estructura (opcional)</label>
      <div class="flex gap-2 items-start">
        <input id="captura-color-estructura" [ngModel]="colorEstructura()" (ngModelChange)="colorEstructura.set($event)" placeholder="Nogal oscuro"
               class="flex-1 min-w-0 border border-[var(--border)] rounded-lg px-3 py-2.5 text-[13.5px] bg-[var(--surface)]" />
        <!-- Montamos la camara solo al solicitarla para proteger el layout movil. -->
        @if (colorEstructuraFoto()) {
          <button type="button" (click)="mostrarCamaraEstructura.set(true)" class="shrink-0">
            <app-mini-foto-blob [blob]="colorEstructuraFoto()!" alt="Color de estructura" className="w-11 h-11 rounded-lg object-cover border border-[var(--border)]" />
          </button>
        } @else {
          <button type="button" (click)="mostrarCamaraEstructura.set(true)"
                  aria-label="Tomar foto del color de estructura"
                  class="shrink-0 w-11 h-11 rounded-lg border border-dashed border-[var(--faint)] text-[16px] flex items-center justify-center">
            📷
          </button>
        }
      </div>
      @if (mostrarCamaraEstructura()) {
        <div class="mt-2">
          <app-camara-captura
            etiqueta="Foto color de estructura"
            (foto)="alCapturarColorEstructura($event)"
            [fotoPreviaUrl]="colorEstructuraFotoPreviaUrl()"
          />
        </div>
      }
    </div>
    <div>
      <p class="block text-[10px] font-bold uppercase tracking-wide text-[var(--faint)] mb-1">Atributos especiales</p>
      <app-banco-chips [banco]="bancoAtributos()" [seleccionados]="atributos()" [multiple]="true" variante="color"
                        (cambiar)="atributos.set($event)" [onAgregarAlBanco]="alAgregarAtributo.bind(this)" [onEliminarDelBanco]="alEliminarAtributo.bind(this)" />
    </div>
    <div>
      <label for="captura-notas" class="block text-[10px] font-bold uppercase tracking-wide text-[var(--faint)] mb-1">Notas</label>
      <textarea id="captura-notas" [ngModel]="notas()" (ngModelChange)="notas.set($event)" placeholder="Medidas, material…"
                class="w-full border border-[var(--border)] rounded-lg px-3 py-2.5 text-[13.5px] min-h-16 bg-[var(--surface)]"></textarea>
    </div>

    @if (mensajeProducto()) {
      <p [class]="claseMensajeProducto(mensajeProducto())">
        {{ mensajeProducto() }}
      </p>
    }

    <button (click)="productoListo()" class="w-full text-[15px] font-bold py-4 rounded-xl text-white mt-2" style="background: var(--sage)">
      ✅ Producto listo → siguiente
    </button>
    <button (click)="terminarProveedor()" class="w-full text-[13.5px] font-semibold py-3 rounded-xl text-[var(--muted)] border border-[var(--border)]">
      Terminar proveedor
    </button>
  </div>

  @if (detalleProducto(); as dp) {
    <div class="fixed inset-0 z-30 bg-black/45 flex items-end sm:items-center justify-center p-3">
      <div class="w-full max-w-md bg-[var(--surface)] rounded-t-2xl sm:rounded-2xl border border-[var(--border)] shadow-xl max-h-[85vh] overflow-hidden flex flex-col">
        <div class="px-4 py-3 border-b border-[var(--border)] flex items-start justify-between gap-3">
          <div>
            <div class="font-mono text-[13px] font-bold text-[var(--blue-ink)]">{{ dp.productoId }}</div>
            <div class="text-[11.5px] text-[var(--muted)] mt-0.5">
              {{ dp.sincronizado === 1 ? 'Guardado online' : 'Guardado local — falta sincronizar' }}
            </div>
          </div>
          <button (click)="cerrarDetalle()" class="text-[12px] font-semibold text-[var(--coral-ink)]">Cerrar</button>
        </div>

        <div class="p-4 overflow-y-auto space-y-3.5">
          @if (dp.fotosBlobs.length > 0) {
            <div>
              <p class="text-[10.5px] font-bold uppercase tracking-wide text-[var(--faint)] mb-1.5">Fotos del mueble</p>
              <div class="flex flex-wrap gap-2">
                @for (f of detalleFotosBlobs(); track f.id) {
                  <div class="text-center">
                    <app-mini-foto-blob [blob]="f.blobReal" [alt]="f.etiqueta || 'foto'" className="w-14 h-14 rounded-lg object-cover border border-[var(--border)]" />
                    @if (f.etiqueta) {
                      <div class="text-[10px] text-[var(--muted)] mt-0.5">{{ f.etiqueta }}</div>
                    }
                  </div>
                }
              </div>
            </div>
          }

          @if (dp.telas.length > 0) {
            <div>
              <p class="text-[10.5px] font-bold uppercase tracking-wide text-[var(--faint)] mb-1.5">
                Telas ({{ dp.telas.length }})
              </p>
              <div class="space-y-2">
                @for (t of detalleTelasBlobs(); track t.id) {
                  <div class="flex items-center gap-2.5 border border-[var(--border)] rounded-lg px-2.5 py-2">
                    <div class="flex gap-1 shrink-0">
                      @if (t.fotoFrenteBlobReal) {
                        <app-mini-foto-blob [blob]="t.fotoFrenteBlobReal" alt="Frente" className="w-10 h-10 rounded-md object-cover border border-[var(--border)]" />
                      }
                      @if (t.fotoReversoBlobReal) {
                        <app-mini-foto-blob [blob]="t.fotoReversoBlobReal" alt="Reverso" className="w-10 h-10 rounded-md object-cover border border-[var(--border)]" />
                      }
                    </div>
                    <div class="min-w-0">
                      <div class="font-mono text-[10px] text-[var(--blue-ink)]">{{ t.muestrario || t.id }}</div>
                      <div class="text-[12.5px] font-bold">{{ t.colores.join(', ') || 'Sin color' }}</div>
                      <div class="text-[11px] text-[var(--muted)]">{{ t.tipo || 'Sin tipo' }}</div>
                    </div>
                  </div>
                }
              </div>
            </div>
          }

          <div>
            <p class="text-[10.5px] font-bold uppercase tracking-wide text-[var(--faint)] mb-1.5">Datos del producto</p>
            <div class="text-[12.5px] text-[var(--ink)] space-y-1">
              <div>FOB: {{ dp.fob !== undefined ? '$' + dp.fob + ' USD' : '—' }}</div>
              <div>MOQ: {{ dp.moq || '—' }}</div>
              <div>Unidades/contenedor: {{ dp.unidadesPorContenedor || '—' }}</div>
              <div class="flex items-center gap-2">
                Color estructura: {{ dp.colorEstructura || '—' }}
                @if (detalleColorEstructuraBlob(); as colorBlob) {
                  <app-mini-foto-blob [blob]="colorBlob" alt="Color estructura" className="w-8 h-8 rounded-md object-cover border border-[var(--border)]" />
                }
              </div>
              <div>Atributos: {{ dp.atributosEspeciales.join(', ') || '—' }}</div>
              <div>Notas: {{ dp.notas || '—' }}</div>
            </div>
          </div>
        </div>

        <div class="px-4 py-3 border-t border-[var(--border)] space-y-2">
          <button
            type="button"
            (click)="iniciarEdicion(dp)"
            class="w-full text-[13.5px] font-bold py-3 rounded-lg text-white"
            style="background: var(--blue)"
          >
            ✎ Editar este producto
          </button>
          <button
            type="button"
            (click)="pedirBorrarProducto()"
            class="w-full text-[13.5px] font-bold py-3 rounded-lg border border-[var(--coral-ink)] text-[var(--coral-ink)]"
          >
            🗑 Eliminar este producto
          </button>
        </div>
      </div>
    </div>
  }

  @if (confirmandoBorrarProducto()) {
    <div class="fixed inset-0 z-40 bg-black/45 flex items-end sm:items-center justify-center p-3">
      <div class="w-full max-w-sm bg-[var(--surface)] rounded-2xl border border-[var(--border)] shadow-xl p-4">
        <p class="text-[13.5px] font-bold mb-1.5">¿Eliminar este producto?</p>
        <p class="text-[12px] text-[var(--muted)] mb-3">
          Esto tambi&eacute;n elimina todas sus telas guardadas. No se puede deshacer.
        </p>
        <div class="flex items-center gap-2.5">
          <button type="button" (click)="cancelarBorrarProducto()" class="flex-1 text-[13px] font-semibold py-2.5 rounded-lg border border-[var(--border)]">
            Cancelar
          </button>
          <button
            type="button"
            (click)="confirmarBorrarProducto()"
            [disabled]="eliminandoProducto()"
            class="flex-1 text-[13px] font-bold py-2.5 rounded-lg text-white disabled:opacity-50"
            style="background: var(--coral-ink)"
          >
            {{ eliminandoProducto() ? 'Eliminando…' : 'Eliminar' }}
          </button>
        </div>
      </div>
    </div>
  }
</div>
}
